import React, { Component } from 'react';
import './styles.css';
import { titleHead } from './../../../services/helper'

class Page404 extends Component {
    componentDidMount() {
        titleHead('404')
    }

    render() {
        return (
            <div
                className="app flex-row align-items-center"
                style={{ "justifyContent": "center", textAlign: 'center', marginTop: '100px' }}>
                <div>
                    <h1 className="float-left display-3 mr-4" style={{ fontSize: '40px' }}>404</h1>
                    <h4 className="pt-3" style={{ fontSize: '17px' }}>Oops! You're lost.</h4>
                    <p className="text-muted float-left">The page you are looking for was not found.</p>
                </div>
            </div>
        );
    }
}

export default Page404;


// WEBPACK FOOTER //
// ./src/containers/exception/404/index.js